<template>
    <div style="min-height: calc(100vh - 158px);">
        <div style="min-height: calc(100vh - 168px);" class="card">
            <div style="background: #DBE7F2" class="pb-1">
                <TitleButton
                    class="px-2 pt-2"
                    :showBtn="false"
                    title="Statement of Cash Flows"
                    :show-filter-btn="true"
                    @onClickFilterButton="onClickFilterButton"
                />
                <div class="px-2">
                    <DateQuerySetter
                        btnTitle="Go"
                        @onClickGo="onClickGo"
                    />
                </div>
            </div>

            <div class="mt-2"></div>
            <div class="">
                <button class="btn btn-success float-end me-4" @click="exportCashFlowStatement">Export</button>
            </div>
            <div
                class="d-flex justify-content-between bg-white sticky px-2 mx-auto z-999 w-100 max-width-640"
                :class="{
                    'opacity-50': accountingLoading,
                    'opacity-100': !accountingLoading
                }"
            >
                <p class="cursor-pointer text-decoration-underline fw-bolder text-primary" @click="expandAll">
                    {{ isExpanded ? 'Collapse All' : 'Expand All' }}
                </p>
            </div>
            <div
                class="d-flex justify-content-between bordered bg-white sticky py-1 px-2 border-t border-b mx-auto z-999 max-width-640 w-100"
                :class="{
                    'opacity-50': accountingLoading,
                    'opacity-100': !accountingLoading
                }"
            >
                <strong class="font-medium-2">Particulars</strong>
                <strong class="font-medium-2">Amount</strong>
            </div>

            <div
                class="px-2 mt-1 mx-auto max-width-640 w-100"
                :class="{
                    'opacity-50': accountingLoading,
                    'opacity-100': !accountingLoading
                }"
            >
                <!-- operatingActivity -->
                <span> A. Cash Flow from Operating Activity</span>
                <div class="card">
                    <CashFlowTree
                        v-for="(operatingItem, i) in operatingActivity"
                        :key="i"
                        :node="operatingItem"
                        ref="operatingTree"
                    />
                    <div class="d-flex justify-content-between border-b-2-dark node-hover node-hover">
                        <strong>TOTAL Cash Flow from Operating Activity</strong>
                        <strong> {{ commaFormat(getTotal(operatingActivity), noOfDecimals) }}</strong>
                    </div>
                </div>

                <!-- operatingActivity -->
                <!-- investingActivity -->
                <span> B. Cash Flow from Investing Activity</span>
                <div class="card">
                    <CashFlowTree
                        v-for="(investingItem, i) in investingActivity"
                        :key="i"
                        :node="investingItem"
                        ref="investingTree"
                    />
                    <div class="d-flex justify-content-between border-b-2-dark node-hover">
                        <strong>TOTAL Cash Flow from Investing Activity</strong>
                        <strong>{{ commaFormat(getTotal(investingActivity), noOfDecimals) }}</strong>
                    </div>
                </div>
                <!-- investingActivity -->
                <!-- financingActivity -->
                <span> C. Cash Flow from Financing Activity</span>
                <div class="card">
                    <CashFlowTree
                        v-for="(financingItem, i) in financingActivity"
                        :key="i"
                        :node="financingItem"
                        ref="financingTree"
                    />
                    <div class="d-flex justify-content-between border-b-2-dark node-hover">
                        <strong>TOTAL Cash Flow from Financing Activity</strong>
                        <strong>{{ commaFormat(getTotal(financingActivity), noOfDecimals) }}</strong>
                    </div>
                    <div class="d-flex justify-content-between border-b-2-dark node-hover">
                        <strong>TOTAL Cash Flow</strong>
                        <strong>
                            {{
                                commaFormat(
                                    getTotal(operatingActivity) +
                                    getTotal(financingActivity) +
                                    getTotal(investingActivity)
                                    , noOfDecimals
                                )
                            }}
                        </strong>
                    </div>
                    <div class="d-flex justify-content-between border-b-2-dark node-hover">
                        <strong>Opening Balance (Cash & bank)</strong>
                        <strong>
                            {{
                                commaFormat(getTotal(cashAndBanks, 'cash_flow_total'), noOfDecimals)
                            }}
                        </strong>
                    </div>
                    <div class="d-flex justify-content-between border-b-2-dark node-hover">
                        <strong>Closing Balance (Cash & bank)</strong>
                        <strong>
                            {{
                                commaFormat(getTotal(cashAndBanks, 'total'), noOfDecimals)
                            }}
                        </strong>
                    </div>
                </div>
                <!-- financingActivity -->
            </div>
        </div>
        <FilterModal v-if="isModalOpen" @on-filter="onFilter"/>
        <Loader v-if="accountingLoading"/>
    </div>
</template>

<script>
import handleAccounting from '@/services/modules/accounting'
import figureFormatter from '@/services/utils/figureFormatter'
import {inject} from 'vue'

import TitleButton from '@/components/atom/TitleButton'
import DateQuerySetter from '@/components/atom/DateQuerySetter'
import Loader from '@/components/atom/LoaderComponent'
import FilterModal from "@/components/atom/FilterModal.vue";
import ContactDropdownFilter from "@/components/atom/Contact/ContactDropdownFilter.vue";
import CashFlowTree from "@/components/molecule/company/report/CashFlowTree.vue";

export default {
    name: 'CashFlowStatement',

    components: {
        CashFlowTree,
        ContactDropdownFilter,
        FilterModal,
        TitleButton,
        DateQuerySetter,
        Loader
    },

    data: () => ({
        operatingActivity: [],
        investingActivity: [],
        financingActivity: [],
        cashAndBanks: [],
        cashFlowStatementData: [],
        showFilterModal: false,
    }),

    computed: {
        companyId() {
            return this.$route.params.companyId
        },

        start() {
            return this.$route.query.start
        },

        end() {
            return this.$route.query.end
        },
        noOfDecimals() {
            return this.$route.query.decimals ?? 2
        },
        token() {
            return localStorage.getItem('token')
        },
        isModalOpen() {
            return this.$store.state.isModalOpen
        },
        isExpanded() {
            return this.$route.query.expand_all ? !!parseInt(this.$route.query.expand_all) : false;
        }
    },

    methods: {
        exportCashFlowStatement() {
            let url = `${process.env.VUE_APP_BASE_URL}/export/accounting/cash-flow-statement` + this.getQuery() + `&_token=${this.token}`;
            let a = document.createElement("a")
            a.setAttribute("href", url)
            a.click()
        },
        getTotal(data, key='cash_flow_diff') {
            let total = 0
            data.map(i => {
                total += i[key]
            })
            return total
        },

        onClickGo(filter) {
            this.getCashFlowStatementData(this.getQuery(filter))
        },

        getQuery(filter) {
            const routeQuery = Object.assign({}, this.$route.query)
            const decimals = filter ? filter.decimals : routeQuery.decimals
            const showNonZero = filter ? filter.showNonZero : (routeQuery.show_non_zero ?? 1)

            let query = '?company_id=' + this.companyId
            if (!this.start && !this.end) return query
            if (this.start) query += '&start_date=' + this.start
            if (this.end) query += '&end_date=' + this.end
            if (decimals) query += `&decimals=${decimals}`
            if (showNonZero) query += `&show_non_zero=${showNonZero}`
            return query
        },

        onFilter(filter) {
            let routeQuery = Object.assign({}, this.$route.query);
            routeQuery.decimals = filter.decimals;
            routeQuery.show_non_zero = filter.showNonZero;
            this.$router.push({path: this.$route.path, query: routeQuery})
            this.onClickGo(filter)
        },

        expandAll() {
            const routeQuery = Object.assign({}, this.$route.query);
            const expandAll = !this.isExpanded;
            routeQuery.expand_all = expandAll ? 1 : 0;
            this.$router.push({path: this.$route.path, query: routeQuery})

            if (this.$refs.operatingTree) {
                this.$refs.operatingTree.forEach(child => child.expandTree(expandAll));
            }

            if (this.$refs.investingTree) {
                this.$refs.investingTree.forEach(child => child.expandTree(expandAll));
            }

            if (this.$refs.financingTree) {
                this.$refs.financingTree.forEach(child => child.expandTree(expandAll));
            }
        },

        async getCashFlowStatementData(query = '') {
            try {
                this.accountingLoading = true
                let res = await this.getCashFlowStatement(query)
                if (!res.status) {
                    this.showError(res.response.message)
                }
                if (res.status) {
                    this.cashFlowStatementData = res.data
                    this.operatingActivity = res.data.cf_operating ? res.data.cf_operating : []
                    this.investingActivity = res.data.cf_investing ? res.data.cf_investing : []
                    this.financingActivity = res.data.cf_financing ? res.data.cf_financing : []
                    this.cashAndBanks = res.data.cash_and_bank ? res.data.cash_and_bank : []
                }
            } catch (err) {
                if (!err.response) {
                    this.showError('Something is wrong. Check your connectivity!!')
                    return;
                }

                if (err.response.data) {
                    this.showError(err.response.data.message)
                }
            } finally {
                this.accountingLoading = false
            }
        },

        onClickFilterButton() {
            this.$store.state.isModalOpen = true
        },
    },

    setup() {
        const showError = inject('showError');
        const showSuccess = inject('showSuccess');

        const {
            getCashFlowStatement,
            accountingLoading
        } = handleAccounting()

        const {commaFormat} = figureFormatter()

        return {
            getCashFlowStatement,
            accountingLoading,
            commaFormat,
            showError,
            showSuccess,
        }
    },

    mounted() {
        this.getCashFlowStatementData(this.getQuery())
    }
}
</script>

<style scoped>
span {
    font-size: 1.2em;
}

.border-t {
    border-top: 1px solid #ebe9f1;
}

.border-b {
    border-bottom: 1px solid #ebe9f1;
}
</style>
